import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SpinnerService implements OnDestroy {
  private _loading = new BehaviorSubject<boolean>(false);

  public readonly loading$ = this._loading.asObservable();

  constructor() {}

  show(): void {
    this._loading.next(true);
  }

  hide(): void {
    this._loading.next(false);
  }

  ngOnDestroy(): void {
    this._loading.next(false);
    this._loading.complete();
  }
}
